import { render, staticRenderFns } from "./AccountReady.vue?vue&type=template&id=ed8d5d12&"
import script from "./AccountReady.vue?vue&type=script&lang=js&"
export * from "./AccountReady.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports